import { SignalrClient } from '@ac/library-api';
import { LoginService } from '@ac/library-utils/dist/services';

export const BackendNotificationsClient = new SignalrClient(
  acConfig.apiUrl,
  () => LoginService.accessToken() || '',
  (LoginService.authData() || { tenantId: '' }).tenantId
);
